import { useL10NStore} from '@/stores/i18n.store';
import get from 'lodash.get';
import { DEFAULT_PREFERENCES } from '@/services/preferences';
export default function i18nServiceFactory(services) {
  const LOCALE_COOKIE_NAME = 'pos.rn.locale';

  const TIME_ZONE_EXCLUSIONS = [
    "America/Knox_IN",
    "Australia/ACT",
    "Australia/LHI",
    "Australia/North",
    "Australia/NSW",
    "Australia/Queensla",
    "Australia/South",
    "Australia/Tasmania",
    "Australia/Victoria",
    "Australia/West",
    "Brazil/Acre",
    "Brazil/DeNoronha",
    "Brazil/East",
    "Brazil/West",
    "Canada/Atlantic",
    "Canada/Central",
    "Canada/Eastern",
    "Canada/Mountain",
    "Canada/Newfoundlan",
    "Canada/Pacific",
    "Canada/Saskatchewa",
    "Canada/Yukon",
    "CET",
    "Chile/Continental",
    "Chile/EasterIsland",
    "CST6CDT",
    "Cuba",
    "EET",
    "Egypt",
    "Eire",
    "EST",
    "EST5EDT",
    "Etc/GMT",
    "Etc/GMT+0",
    "Etc/GMT-0",
    "Etc/GMT0",
    "Etc/GMT+1",
    "Etc/GMT+10",
    "Etc/GMT+11",
    "Etc/GMT+12",
    "Etc/GMT+2",
    "Etc/GMT+3",
    "Etc/GMT+4",
    "Etc/GMT+5",
    "Etc/GMT+6",
    "Etc/GMT+7",
    "Etc/GMT+8",
    "Etc/GMT+9",
    "Etc/GMT-1",
    "Etc/GMT-10",
    "Etc/GMT-11",
    "Etc/GMT-12",
    "Etc/GMT-13",
    "Etc/GMT-14",
    "Etc/GMT-2",
    "Etc/GMT-3",
    "Etc/GMT-4",
    "Etc/GMT-5",
    "Etc/GMT-6",
    "Etc/GMT-7",
    "Etc/GMT-8",
    "Etc/GMT-9",
    "Etc/UTC",
    "Etc/Greenwich",
    "Etc/UCT",
    "Etc/Universal",
    "Etc/Zulu",
    "GB",
    "GB-Eire",
    "GMT",
    "GMT+0",
    "GMT0",
    "GMT-0",
    "Greenwich",
    "Hongkong",
    "HST",
    "Iceland",
    "Iran",
    "Israel",
    "Jamaica",
    "Japan",
    "Kwajalein",
    "Libya",
    "MET",
    "Mexico/BajaNorte",
    "Mexico/BajaSur",
    "Mexico/General",
    "MST",
    "MST7MDT",
    "Navajo",
    "NZ",
    "NZ-CHAT",
    "Poland",
    "Portugal",
    "PRC",
    "PST8PDT",
    "ROC",
    "ROK",
    "Singapore",
    "Turkey",
    "UCT",
    "Universal",
    "US/Alaska",
    "US/Aleutian",
    "US/Arizona",
    "US/Central",
    "US/Eastern",
    "US/East-Indiana",
    "US/Hawaii",
    "US/Indiana-Starke",
    "US/Michigan",
    "US/Mountain",
    "US/Pacific",
    "US/Pacific-New",
    "US/Samoa",
    "WET",
    "W-SU",
    "Zulu",
  ];

  let i18nStore;
  return {
    initAsync,
    getLocale,
    getShortLocale,
    setLocaleAsync,
    getLocaleDisplay,
    getLocales,
    getLocaleOptions,
    getShortLocaleOptions,
    getCountriesAsync,
    getCountries,
    getCountryDisplay,
    getCountryOptions,
    getCountryOptionsAsync,
    getLanguageCode,
    getTimeZone,
    getTimeZoneDisplay,
    setTimeZoneAsync,
    getTimeZones,
    getTimeZoneOptions,
    getUnitSystem,
    setUnitSystemAsync,
    getUnitSystemOptions,
    getPaperUsage,
    setPaperUsageAsync,
    getPaperUsageOptions,
    configureForPreferences,
    getNormalizedBcp47Locale,
    tryTranslate,
    getCatalogAsync,
    getCatalogs,
    getCatalog,
    getI18nInstance,
    $t,
  };

  ////////////////////

  function initAsync() {
    i18nStore =  useL10NStore();
    let promises = [];
    promises.push(getCountriesAsync());
    promises.push(getHeaderCatalogsAsync());
    promises.push(setLocaleAsync(services.i18n.getLocale()))
    return Promise.all(promises).then(() => {
      services.session.sendClientEvent('posb-locale-changed');
    });
  }


  function getHeaderCatalogsAsync() {
    let promises = [];
    promises.push(getCatalogAsync('uxf', 'portal_service'));
    promises.push(getCatalogAsync('market', 'portal_service'));
    promises.push(getCatalogAsync('notification', 'notification_service'));
    promises.push(getCatalogAsync('application', 'portal_service', 'app'));
    promises.push(getCatalogAsync('feature', 'portal_service', 'feature'));
    promises.push(getCatalogAsync('devices', 'portal_service', 'devices'));
    return Promise.all(promises);
  }

  function $t(key, params) {
    return i18nStore.i18n.global.t(key, params);
  }

  function getI18nInstance() {
    return i18nStore.i18n;
  }

  function getCatalogAsync(catalogId, service, alias, locale) {
    let myService = service ? service : undefined;
    let catalogEntry = alias ? alias : catalogId;
    let myLocale = locale ? locale : services.i18n.getShortLocale();
    if (!catalogId) {
      console.warn('(PrintOS Header API) getCatalog: Invalid catalogId.  Parameter 1 must be a valid catalog id.');
      return Promise.resolve({});
    }

    if (!service) {
      console.warn('(PrintOS Header API) getCatalog: Invalid service.  Parameter 2 must be a valid service id.');
      return Promise.resolve({});
    }

    const cachedCatalog = i18nStore.getCatalog(catalogId, myService, myLocale);
    if (cachedCatalog) {
      return Promise.resolve(cachedCatalog);
    }

    return services.http.get(service, `i18n/${catalogId}/${myLocale}`, {}).then(resp => {
      let myMessages = {};
      resp.data.messages.forEach(m => {
        myMessages[m.msgId] = m.msgText;
      });

      let storedMessages = i18nStore.i18n.global.getLocaleMessage(myLocale);
      if (!storedMessages[catalogEntry]) {
        storedMessages[catalogEntry] = myMessages;
        i18nStore.i18n.global.setLocaleMessage(myLocale, storedMessages);
      }

      i18nStore.setCatalog(catalogId, myService, myLocale, myMessages);
      return myMessages;
    })
      .catch(e => {
        // unfortunate but we don't want to break for a failed catalog lookup
        console.warn(`getCatalog - Error (id=${catalogId}, service=${service}, locale=${myLocale})`, e);
        return Promise.resolve({});
      });
  }

  function getCatalogs(locale) {
    let myLocale = locale ? locale : services.i18n.getShortLocale();
    let storedMessages = i18nStore.i18n.global.getLocaleMessage(myLocale);
    return Object.keys(storedMessages);
  }

  function getCatalog(catalogId, locale) {
    let myLocale = locale ? locale : services.i18n.getShortLocale();
    let storedMessages = i18nStore.i18n.global.getLocaleMessage(myLocale);
    return storedMessages[catalogId];
  }

  /**
   * Adds a set of messages to a specific key path for the current locale.
   *
   * @param keyPath {string} to add the messages to in the current locale
   * @param messages {object} messages to add to the current locale
   * @returns {object} the updated locale
   */
  // function extendCurrentLocale(keyPath = '', messages = {}) {
  //   let lang = Vue.config.lang;
  //   if (!includes(requireLocale.keys(), `./${lang}.js`)) {
  //     // Fallback to English (required for partial translation)
  //     lang = 'en';
  //   }
  //
  //   let currentLocale = requireLocale(`./${lang}.js`).default;
  //   set(currentLocale, keyPath, messages);
  //   Vue.locale(lang, currentLocale);
  //   return currentLocale;
  // }

  function getUnitSystem() {
    let pref = services.preferences.getPreference('unitSystem', 'general');
    return pref ? pref : 'Imperial';
  }

  function getLocale() {
    let localePref = services.preferences.getPreference('general.locale');
    return localePref ? localePref : window.navigator.language;
  }

  function getShortLocale() {
    let locale = getLocale();
    return locale.split('-')[0];
  }

  function setLocaleAsync(locale) {
    let currentLocale = services.preferences.getPreference('locale', 'general');
    if (currentLocale === locale) {
      return Promise.resolve();
    }
    services.window.document.documentElement.lang = locale;
    return services.preferences.setPreferenceAsync('locale', locale, 'general').finally(() => {
      updateLocaleCookie(locale);
      configureForPreferences();
      let promises = [];
      promises.push(getHeaderCatalogsAsync());
      //promises.push(services.session.getClientConfigAsync(true));
      return Promise.all(promises).finally(() => {
        services.session.sendClientEvent('posb-locale-changed');
      });
    });
  }

  function setLocaleCookie(locale) {
    services.window.document.documentElement.lang = locale;
  }

  function updateLocaleCookie(locale) {
    let cookiePreferences = services.preferences.getLocalStorageObject('pros-preferences', DEFAULT_PREFERENCES);
    if (!cookiePreferences) {
      cookiePreferences = DEFAULT_PREFERENCES;
    }
    services.helpers.set(cookiePreferences, 'general.locale', locale);
    services.preferences.setLocalStorageObject('pros-preferences', cookiePreferences);

    // Legacy: Need to keep doing this for as long as Rhino/Gazelle are still being used
    services.preferences.setCookieObject(LOCALE_COOKIE_NAME, {locale:cookiePreferences.general.locale});
  }

  function getLocaleDisplay(locale) {
    let found = getLocales(true).find(l => { return l.value === locale });
    return found ? found.language : null;
  }

  function getLocaleOptions(includeLimited = false) {
    const locales = getLocales(includeLimited);
    let options = [];
    locales.forEach(l => {
      options.push({
        display: l.language,
        details: $t(`uxf.${l.value}`),
        value: l.value
      });
    });

    return options;
  }

  function getShortLocaleOptions(includeLimited = false) {
    const locales = getLocales(includeLimited);
    let options = [];
    locales.forEach(l => {
      options.push({
        display: l.language,
        details: $t(`uxf.${l.value}`),
        value: getShortLocale(l.value),
      });
    });

    return options;
  }

  function getCountriesAsync() {
    const config = {
      params: {
        locale: getLocale().value
      }
    };

    return services.http.get('portal_service', 'preferences/countries', config).then(resp => {
      let countries = resp.data ? resp.data : [];
      i18nStore.setCountries(countries);
      return countries;
    });
  }

  function getCountries() {
    return i18nStore.countries ? i18nStore.countries : [];
  }

  function getCountryDisplay(countryCode) {
    let countries = i18nStore.countries;
    let found = countries.find(c => {
      return c.isoCode === countryCode;
    });

    return found ? found.localizedName : null;
  }

  function getCountryOptionsAsync() {
    return getCountriesAsync().then(countries => {
      let countryOptions = [];
      countries.forEach(country => {
        countryOptions.push({
         display: country.localizedName,
         value: country,
        });
      });

      countryOptions = countryOptions.sort((a,b) => {
        return a.display.toLocaleLowerCase().localeCompare(b.display.toLocaleLowerCase());
      });

      return countryOptions;
    });
  }

  function getCountryOptions() {
    let countries = i18nStore.countries;
   let countryOptions = [];
    countries.forEach(country => {
      countryOptions.push({
       display: country.localizedName,
       value: country,
      });
    });

    countryOptions = countryOptions.sort((a,b) => {
      return a.display.toLocaleLowerCase().localeCompare(b.display.toLocaleLowerCase());
    });

    return countryOptions;
  }



  function getLocales(includeLimited = false) {
    let cc = services.session.getClientConfig();
    let locales = get(cc, 'preferences.options.locales', []);
    let features = cc.features || [];
    let cookieLocale = services.preferences.getCookieObject(LOCALE_COOKIE_NAME);
    locales = locales.filter(l => {
      if (cookieLocale && l.value === cookieLocale.locale) {
        return true;
      }

      if (!includeLimited && l.limited) {
        return false;
      }

      if (!l.features) {
        return true;
      }

      for (let i = 0; i < l.features.length; i++) {
        if (features.includes(l.features[i])) {
          return true;
        }
      }

      return false;
    });

    return locales;
  }

  function getLanguageCode() {
      return getLocale().split('-')[0];
  }

  // Returns the BCP47 locale (for example, 'fr-FR', 'en-UK')
  function getNormalizedBcp47Locale() {
    let locale = getLocale();
    return locale === 'zh-HANS' ? 'zh-CN' : locale;
  }

  function getTimeZone() {
    let tzPref = services.preferences.getPreference('timeZone', 'general');
    return tzPref ? tzPref : Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  function getTimeZoneDisplay(tz, offset = false) {
    return `(${services.date.getTimeZoneOffsetString(tz)} ${tz}`;
  }

  function setTimeZoneAsync(tz) {
    if (tz) {
      return services.preferences.setPreferenceAsync('timeZone', tz, 'general').then(() => {
      });
    }
    else {
      return services.preferences.deletePreferenceAsync('timeZone', 'general').then(() => {
      });
    }
  }

  function getTimeZones() {
    return Intl.supportedValuesOf('timeZone').filter(tz => {
      return !TIME_ZONE_EXCLUSIONS.includes(tz);
    });
  }

  function getTimeZoneOptions() {
    let timeZones = getTimeZones();
    let timeZoneOptions = timeZones.map(tz => {
      return {
        display: tz,
        details: services.date.getTimeZoneOffsetString(tz),
        value: tz
      }
    });

    timeZoneOptions = timeZoneOptions.sort((a,b) => {
      let offsetA = services.date.getTimeZoneOffset(a.value);
      let offsetB = services.date.getTimeZoneOffset(b.value);
      if (offsetA === offsetB) {
        return a.display.toLocaleLowerCase().localeCompare(b.display.toLocaleLowerCase());
      }

      return offsetA - offsetB;
    });

    timeZoneOptions.unshift({
      display: services.i18n.$t('uxf.BrowserDefault'),
      value: null,
    });
    return timeZoneOptions;
  }


  function getPaperUsage() {
    let paperUsage = services.preferences.getPreference('paperUsage', 'general');
    return paperUsage ? paperUsage : null;
  }

  function setPaperUsageAsync(paperUsage) {
    if (paperUsage) {
      return services.preferences.setPreferenceAsync('paperUsage', paperUsage, 'general');
    }
    else {
      return services.preferences.deletePreferenceAsync('paperUsage', 'general');
    }
  }

  function getPaperUsageOptions() {
    return [
      {
        display: services.i18n.$t('uxf.PaperUsage_Equivalent'),
        value: 'EquivalentPages'
      },
      {
        display: services.i18n.$t('uxf.PaperUsage_SquareArea'),
        value: 'SquareArea'
      }
    ];

  }

  function setUnitSystemAsync(unitSystem) {
    return services.preferences.setPreferenceAsync('unitSystem', unitSystem, 'general').then(() => {
    });
  }

  function getUnitSystemOptions() {
    let cc = services.session.getClientConfig();
    let unitSystems = get(cc, 'preferences.options.unitSystems', []);
    return unitSystems.map(us => {
      return {
        display: us.value,
        value: us.value,
      }
    });
  }

  function configureForPreferences() {
    // configureVueI18n();
    configureDocLang();
  }

  // function configureVueI18n() {
  //   Vue.config.lang = getLanguageCode();
  // }

  function configureDocLang() {
    services.document.documentElement.lang = getNormalizedBcp47Locale();
  }

  function tryTranslate(prefix, value, params) {
    const key = prefix ? `${prefix}.${value}` : value;
    return i18nStore.i18n.global.te(key) ? $t(key, params) : value;
  }
}
